import BarChart from '@material-ui/icons/BarChart'
import CastIcon from '@material-ui/icons/Cast'
import ShareIcon from '@material-ui/icons/Share'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import VideocamIcon from '@material-ui/icons/Videocam'
import React from 'react'

const subscriptionIconMapper = {
  Stats: <BarChart />,

  Livestream: <CastIcon />,

  Engage: <ShareIcon />,

  Fans: <PeopleAltIcon />,

  Studio: <VideocamIcon />,

  ViewStats: <BarChart />,
}

export default subscriptionIconMapper
